import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

function useManageClass() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addClass(data) {
    return privateFetch.post(`/v1/admin/class`, data);
  }

  function updateClass(classID, data) {
    return privateFetch.put(`/v1/admin/class/${classID}`, data);
  }

  function manageClass(data = {}) {
    if (data?.id) {
      return updateClass(data.id, data);
    }

    return addClass(data);
  }

  return useMutation(manageClass, {
    onSuccess() {
      history.goBack();
    },
    onSettled() {
      queryClient.invalidateQueries('class-lists');
    },
  });
}

export default useManageClass;
